import { AccountsInterestParam, PatchAccountInterestParam } from "@/Interfaces/I_AccountsInterest";
import { customAxios } from "..";

export const fetchAccountsInterest = (data: AccountsInterestParam) =>
  customAxios({
    url: 'hktv_koc/cms/accounts/interest',
    method: 'GET',
    params: data,
  });

export const putAccountsInterest = (data: PatchAccountInterestParam) => 
  customAxios.put('hktv_koc/cms/accounts/interest', data);